import {isNullOrUndefined} from "../../../services/Validator";

export default function ThemesItemNameText({themeName}) {
    // Used in ThemesItem to display one single Theme
    // name text

    // BUILD
    if (isNullOrUndefined(themeName))
        return null
    return (
        <div>
            <span className={"text-[16px] lg:text-[18px] text-primaryLight2 font-semibold"}>
                {themeName}
            </span>
        </div>
    );
}